import app from './app/app.reducers'

export default {
    app
}